import { gsap } from "gsap";

import { MorphSVGPlugin } from "../../plugins/MorphSVGPlugin"
import { ScrollTrigger } from "gsap/ScrollTrigger";

const CLASSNAME_SHOW      = 'is-shown';
const CLASSNAME_SHOW_ASC  = 'is-shown-asc';
const CLASSNAME_SHOW_DESC = 'is-shown-desc';
const CLASSNAME_HIDE      = 'is-hidden';
const CLASSNAME_HIDE_ASC  = 'is-hidden-asc';
const CLASSNAME_HIDE_DESC = 'is-hidden-desc';
const CLASSNAME_CURRENT   = 'is-current';
const CLASSNAME_ANIMATE   = 'has-animate';

gsap.registerPlugin( MorphSVGPlugin, ScrollTrigger );

class PageAbout {
    constructor() {
        this.isAnimating = false;
        this.about = document.getElementById('about-section');
        this.aboutSlides = [...document.querySelectorAll('.about-slide')];
        // this.aboutSlideSpacers = [...document.querySelectorAll('.about-slide-spacer')];
        this.aboutSlidesCount = this.aboutSlides.length;
        this.aboutBackground = document.getElementById('about-background');
        this.morphNumbersWrap = document.getElementById('num-wrap');
        this.morphNumbersEl = document.getElementById('morph-numbers');
        this.morphNumbers = [...document.querySelectorAll('#about-numbers path')];
        this.patternPaths = [...document.querySelectorAll('.about-pattern-path')];
        this.svg = document.getElementById('about-pattern-svg');
        this.pager = document.getElementById('about-paging');
        if(this.pager) {
            this.pages = [...this.pager.querySelectorAll('span')];

            if(this.pages.length > 0) {
                this.pages.forEach((page, index) => {
                    page.addEventListener('click', (e) => {
                        const pageIndex = parseInt(e.target.dataset.index, 10);
                        const scrollTo = (pageIndex + 0.3) * window.innerHeight + this.about.getBoundingClientRect().top + window.scrollY;
                        this.setSlide(index, this.aboutSlides[pageIndex]);
                        window.scrollTo({
                            top: scrollTo,
                        })
                    })
                })
            }
        }
        this.activeSlide = 0;
        if(this.aboutSlidesCount > 0) {
            // this.about.style.height = `${30 * this.aboutSlidesCount}vh`;
        }

        this.init();
        this.initScene()
        this.setBackground(this.aboutSlides[0]);
    }

    init() {
        $(window).on("mousewheel DOMMouseScroll", this.onWheel.bind(this));
    }

    setBackground(section) {
        let color = section.dataset.aboutColor;
        if(!color) {
            color = '#4B5058';
        }

        let patternColor = section.dataset.aboutPatternColor;
        if(!patternColor) {
            patternColor = '#5F636A';
        }

        // this.patternPaths.forEach(path => path.style.stroke = patternColor)
        this.aboutBackground.style.backgroundColor = color;
    }

    start() {
        this.aboutSlides[this.activeSlide].classList.add(CLASSNAME_SHOW);
        this.aboutSlides[this.activeSlide].classList.add(CLASSNAME_SHOW_ASC);
        this.morphNumbersWrap.classList.add('is-active');
    }

    onWheel(e) {
        if (this.isAnimating) {
            e.preventDefault();
        }
    }

    setSlide(id, section) {
        this.isAnimating = true;
        if(this.activeSlide === id) return ;
            // this.aboutSlides.forEach()

        this.isAscend = id > this.activeSlide;
        this.previousSlide = this.activeSlide;
        this.activeSlide = id;

        // this.aboutSlides[this.activeSlide].classList.remove('is-active');
        this.setBackground(section);
        this.svg.style.transform = `rotate(${ id * 45 }deg)`;
        // this.aboutSlides[this.activeSlide].classList.add('is-active');
        this.changeSection();

        if(this.activeSlide >= 0) {


            gsap.to(this.morphNumbersEl, {
                morphSVG: {
                    shape: this.morphNumbers[this.activeSlide]
                },
                duration: 0.5
            })
        } else {
            this.morphNumbersWrap.classList.remove('is-active');
        }

        setTimeout(() => {
            this.isAnimating = false;
        }, 1000);
    }

    changeSection() {
        for (let i = 0; i < this.aboutSlides.length; i++) {
            this.aboutSlides[i].classList.remove(CLASSNAME_SHOW);
            this.aboutSlides[i].classList.remove(CLASSNAME_SHOW_ASC);
            this.aboutSlides[i].classList.remove(CLASSNAME_SHOW_DESC);
            this.aboutSlides[i].classList.remove(CLASSNAME_HIDE);
            this.aboutSlides[i].classList.remove(CLASSNAME_HIDE_ASC);
            this.aboutSlides[i].classList.remove(CLASSNAME_HIDE_DESC);
        }
        if (this.isAscend) {
            this.aboutSlides[this.previousSlide].classList.add(CLASSNAME_HIDE);
            this.aboutSlides[this.previousSlide].classList.add(CLASSNAME_HIDE_ASC);
            this.aboutSlides[this.activeSlide].classList.add(CLASSNAME_SHOW);
            this.aboutSlides[this.activeSlide].classList.add(CLASSNAME_SHOW_ASC);
        } else {
            this.aboutSlides[this.previousSlide].classList.add(CLASSNAME_HIDE);
            this.aboutSlides[this.previousSlide].classList.add(CLASSNAME_HIDE_DESC);
            this.aboutSlides[this.activeSlide].classList.add(CLASSNAME_SHOW);
            this.aboutSlides[this.activeSlide].classList.add(CLASSNAME_SHOW_DESC);
        }

        if(this.pages) {
            this.pages.forEach(page => page.classList.remove('active'));
            this.pages[this.activeSlide].classList.add('active');
        }

        /*if(this.elmPagerPointers.length > 0) {
            this.elmPagerPointers[this.previousSlide].classList.remove(CLASSNAME_CURRENT);
            this.elmPagerPointers[this.activeSlide].classList.add(CLASSNAME_CURRENT);
        }*/

    }

    initScene() {
        this.triggers = [];
        // console.log('window.height', window.innerHeight)
        // console.log('top', this.about.getBoundingClientRect().top)
        // console.log('bottom', this.about.getBoundingClientRect().bottom)
        // console.log('height', this.about.getBoundingClientRect().height)
        this.aboutSlides.forEach((section, i) => {
            /*ScrollTrigger.create({
                trigger: section,
                start: 'top top',
                // when a new section activates (from either direction), set the section accordinglyl.
                // onToggle: self => self.isActive && setSection(section)
                onEnter: (self) => {
                    this.setSlide(i, section)
                    console.log(i)
                    // gsap.to("body", {backgroundColor: colorSection.dataset.scrollcolor, overwrite: 'auto'})
                },
                onLeaveBack: (self) => {
                    this.setSlide(i, section)
                    console.log(i)
                    // gsap.to("body", {backgroundColor: prevColor, overwrite: 'auto'})
                }
            });*/
            let mm = gsap.matchMedia()
            // console.log('start', i * innerHeight + this.about.getBoundingClientRect().top)
            // console.log('end', (i + 1) * innerHeight + this.about.getBoundingClientRect().top)
            mm.add('(min-width: 768px)', () => {
                if(i < this.aboutSlides.length - 1) {
                    this.triggers.push(ScrollTrigger.create({
                        // use dynamic scroll positions based on the window height (offset by half to make it feel natural)
                        start: () => i * innerHeight + this.about.getBoundingClientRect().top,
                        end: () => (i + 1) * innerHeight + this.about.getBoundingClientRect().top,
                        onEnter: (self) => {
                            this.setSlide(i, section)
                        },
                        onEnterBack: (self) => {
                            this.setSlide(i, section)
                        },
                        snap: {
                            snapTo: 1,
                            duration: {min: 0.5, max: 0.5}
                        }
                    }));
                } else {
                    this.triggers.push(ScrollTrigger.create({
                        // use dynamic scroll positions based on the window height (offset by half to make it feel natural)
                        start: () => i * innerHeight + this.about.getBoundingClientRect().top,
                        end: () => (i + 1) * innerHeight + this.about.getBoundingClientRect().top,
                        onEnter: (self) => {
                            this.setSlide(i, section)
                        },
                        onEnterBack: (self) => {
                            this.setSlide(i, section)
                        }
                    }));
                }
            })

            // this.triggers.push(ScrollTrigger.create({
            //     // use dynamic scroll positions based on the window height (offset by half to make it feel natural)
            //     start: () => i * innerHeight / 3 + this.about.getBoundingClientRect().top,
            //     end: () => (i + 1) * innerHeight / 3 + this.about.getBoundingClientRect().top,
            //     onEnterBack: (self) => {
            //         this.setSlide(i, section)
            //     },
            //     // when a new section activates (from either direction), set the section accordinglyl.
            //     // onToggle: self => self.isActive && this.about.getBoundingClientRect().top < 0 && this.setSlide(i, section)
            // }));
        });

        this.start();
        /*function setSection(newSection) {
            if (newSection !== currentSection) {
                gsap.to(currentSection, {scale: 0.8, autoAlpha: 0})
                gsap.to(newSection, {scale: 1, autoAlpha: 1});
                currentSection = newSection;
            }
        }*/


        /*this.scene = gsap.timeline({
            scrollTrigger: {
                trigger: ".about-slide",
                scrub: 1,
                start: "top",
                end: "bottom bottom",
                onEnter: (self) => {
                    console.log(self)
                },
                onEnterBack: (self) => {
                    console.log(self)
                }
            }
        })*/
    }
}

export default PageAbout
